import React from 'react';
import { reduxForm, Field } from 'redux-form';
import CheckboxField from './CheckboxField';
import SelectField from './SelectField';
import { formatSaveStatus } from '../helpers/formatters';
import FormError from './FormError';

let ContractCancel = ({ handleSubmit, saveStatus, error }) => {
  return (
    <div>
      <h3>Cancel Contract</h3>
      <form onSubmit={handleSubmit}>
        <Field
          component={CheckboxField}
          name="force_device_cancellation"
          label="Force Device Cancellation"
        />
        <Field
          component={SelectField}
          name="expiry_type"
          label="Expiry Type"
          empty="Select expiry type"
          options={[
            ['cancel', 'Cancellation'],
            ['port_out', 'Port out'],
            ['nonpayment', 'Non-payment'],
          ]}
        />

        {error && <FormError error={error} />}

        <button className="btn btn-danger" disabled={saveStatus === 'PENDING'}>
          Cancel Contract
        </button>

        <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
      </form>
    </div>
  );
};

const validate = (values) => {
  let errors = {};
  if (!values.expiry_type) {
    errors.expiry_type = 'Required';
  }
  return errors;
};

ContractCancel = reduxForm({
  form: 'contractCancel',
  validate,
})(ContractCancel);

export default ContractCancel;
